import { useContext, useMemo } from 'react';
import { useGroupFeatures } from '@trinity/chat-components/containers/Chat';
import { ChatDefaultContextItemContext } from '../Chat/context';

export const useChatSettings = () => {
  const features = useGroupFeatures();
  const defaultContext = useContext(ChatDefaultContextItemContext);

  return useMemo(() => ({
    defaultContext,

    hcpProfiles: features.hcpProfiles,
    workspaces: features.workspaces,
    engagementFilter: features.engagementFilter,
  }), [defaultContext, features.engagementFilter, features.hcpProfiles, features.workspaces]);
};